<template>
  <div>
    <router-view name="PageHeaderBar" />
    <div class="content-wrap">
      <div class="container-fluid">
        <div id="user-area" class="nav-wrapper">
          <nav id="side-nav" class="page-nav" :class="{ closed: sideNavClosed }">
            <LeftNavToolbar :class="{ closed: sideNavClosed }" @toggle="toggleSideNav">
              <template #return-link>
                <router-link class="nav-link no-scroll" title="Return to previous page"
                  aria-label="A control that returns to the previous page" :to="{ name: 'internal-dashboards-root' }">
                  <font-awesome-icon :icon="['fas', 'arrow-left']" fixed-width />
                  <span class="sr-only">
                    Return to previous page
                  </span>
                </router-link>
              </template>
            </LeftNavToolbar>
            <UserNav @toggle="toggleSideNav" />
          </nav>
          <div class="page-content">
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { useAppCoreStore } from "@/src/stores/app-core";
import UserNav from "~/src/components/user/UserNav.vue";
import LeftNavToolbar from "@/src/components/shared/LeftNavToolbar.vue";

export default {
  components: {
    UserNav,
    LeftNavToolbar
  },
  setup() {
    const appStore = useAppCoreStore();
    return {
      appStore,
    };
  },
  data() {
    return {
      sideNavClosed: false
    }
  },
  mounted() {
    this.appStore.setAppBreadcrumbs([
      {
        text: 'User Profile',
      },
    ]);
  },
  methods: {
    toggleSideNav() {
      this.sideNavClosed = !this.sideNavClosed;
    }
  }
}
</script>
